export default __webpack_public_path__ + "static/media/toka-city-100.7f5af2f1.png";